// (B) Plain(플레인) DatePicker 백엔드 — antd DatePicker 대체. native <input type=date|datetime-local>.
//   값 계약 = 문자열(date: YYYY-MM-DD / showTime: YYYY-MM-DDTHH:mm, native datetime-local).
//   `.om-date-picker` hook. 소비처 0(kit API 전용) → 이중클래스/공유 SCSS 불필요, native 위젯이 팝업 담당.
import type { OmwDatePickerProps } from '../api/OmwDatePicker'
import { cx } from './cx'
import '../styles/omPicker.css'

export function PlainDatePicker({
  value,
  onChange,
  showTime,
  placeholder,
  disabled,
  className,
  style,
}: OmwDatePickerProps) {
  return (
    <input
      type={showTime ? 'datetime-local' : 'date'}
      className={cx('om-date-picker', className)}
      value={value ?? ''}
      placeholder={placeholder}
      disabled={disabled}
      style={style}
      onChange={(e) => onChange?.(e.target.value)}
    />
  )
}
